import { CoursePageLayout } from "../courseBlocks";
import { mathMenuData } from "../../../data/SubjectMenu/mathMenuData";
import { mathsImg } from "../../../data/SubjectContent/maths/img";
import { mathsDevelopmentBlocks } from "../../../data/SubjectContent/maths/development";

export function PageMathsDevelopment() {
    return (
        <CoursePageLayout
            title="數學科 | 教師專業發展"
            subtitle="PROFESSIONAL DEVELOPMENT OF TEACHERS"
            menuData={mathMenuData}
            nowIndex={4}
            topImage={{ src: mathsImg.developmentTop }}
            blocks={mathsDevelopmentBlocks}
        />
    );
}
